/*新闻*/
import getTranslation from '@/locale/getTranslation'
import base from '@/utils/base'
export default [
  {
    path: '/mobile',
    redirect: '/mobile/news'
  },
  {
    path: '/mobile/news',
    name: 'mobile_news',
    component: resolve => require(['@/views/mobile'], resolve),
    meta: {
      title: getTranslation('新闻中心')
    },
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next()
      } else {
        next({
          name: 'pc_home'
        })
      }
    }
  },
  {
    path: '/mobile/trends',
    name: 'mobile_trends',
    component: resolve => require(['@/views/mobile/newsTrends'], resolve),
    meta: {
      title: getTranslation('新闻动态'),
      keepAlive: true
    },
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next()
      } else {
        next({
          name: 'web_notice',
          query: to.query
        })
      }
    }
  },
  {
    path: '/mobile/notice',
    name: 'mobile_notice',
    component: resolve => require(['@/views/mobile/notice'], resolve),
    meta: {
      title: getTranslation('最新通知'),
      keepAlive: true
    },
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next()
      } else {
        next({
          name: 'pc_cover',
          query: to.query
        })
      }
    }
  },
  {
    path: '/mobile/stories',
    name: 'mobile_stories',
    component: resolve => require(['@/views/mobile/stories'], resolve),
    meta: {
      title: getTranslation('服贸故事'),
      keepAlive: true
    },
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next()
      } else {
        next({
          name: 'pc_stories',
          query: to.query
        })
      }
    }
  },
  {
    path: '/mobile/detail',
    name: 'mobile_detail',
    component: resolve => require(['@/views/mobile/detail'], resolve),
    meta: {
      title: getTranslation('资讯详情')
    },
    beforeEnter: async (to, from, next) => {
      console.log(to)
      if (base.isMobile()) {
        next()
      } else {
        next({
          name: 'pc_consult',
          query: to.query
        })
      }
    }
  },
  {
    path: '/mobile/video',
    name: 'mobile_video',
    component: resolve => require(['@/views/mobile/video'], resolve),
    meta: {
      title: getTranslation('视频新闻')
    },
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next()
      } else {
        next({
          name: 'web_video'
        })
      }
    }
  },
  {
    path: '/mobile/video/detail',
    name: 'mobile_video_detail',
    component: resolve => require(['@/views/mobile/video/detail'], resolve),
    meta: {
      title: getTranslation('视频新闻详情')
    }
  },
  {
    path: '/mobile/picture',
    name: 'mobile_picture',
    component: resolve => require(['@/views/mobile/picture'], resolve),
    meta: {
      title: getTranslation('图片新闻')
    },
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next()
      } else {
        next({
          name: 'web_picture'
        })
      }
    }
  },
  {
    path: '/mobile/picture/detail',
    name: 'mobile_picture_detail',
    component: resolve => require(['@/views/mobile/picture/detail'], resolve),
    meta: {
      title: getTranslation('图片新闻详情')
    },
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next()
      } else {
        next({
          name: 'web_picture_detail'
        })
      }
    }
  },
  {
    path: '/mobile/login',
    name: 'mobile_login',
    component: resolve => require(['@/views/mobile/login/index.vue'], resolve),
    meta: {
      title: getTranslation('媒体登录')
    },
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next()
      } else {
        next({
          name: 'web_login',
          query: to.query
        })
      }
    }
  },
  {
    path: '/mobile/login/error',
    name: 'mobile_login_error',
    component: resolve => require(['@/views/mobile/login/error'], resolve),
    meta: {
      title: getTranslation('注册记者验证')
    },
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next()
      } else {
        next({
          name: 'web_login_error'
        })
      }
    }
  },
  //pc端媒体登录入口页面：
  {
    path: '/web/login',
    name: 'web_login',
    component: resolve => require(['@/views/web/login/index.vue'], resolve),
    meta: {
      title: getTranslation('媒体登录')
    },
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next({
          name: 'mobile_login',
          query: to.query
        })
      } else {
        next()
      }
    }
  },
  //pc端媒体登录后的跳转页面：
  {
    path: '/web/login/error',
    name: 'web_login_error',
    component: resolve => require(['@/views/web/login/check.vue'], resolve),
    meta: {
      title: getTranslation('注册记者验证')
    },
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next({
          name: 'mobile_login_error'
        })
      } else {
        next()
      }
    }
  },
  {
    path: '/mobile/second/list',
    name: 'mobile_list',
    component: resolve => require(['@/views/mobile/data/Index'], resolve),
    beforeEnter: async (to, from, next) => {
      if (base.isMobile()) {
        next()
      } else {
        next({
          name: 'pc_data',
          query: to.query
        })
      }
    }
  }
]
